// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"794":"record-detail","893":"record-list"}[chunkId] + "-legacy." + {"794":"d4620b9a","893":"05d65668"}[chunkId] + ".js";
};